import React, { useEffect } from "react";
import { Autocomplete } from "@sscs/ui";
const CommonListFilter = ({ id, value, options, filterName, filterNamePlural = `${filterName}s`, onOpen, onChange, loading, className, }) => {
    const allOptions = [
        {
            id: "ALL",
            value: `Show all ${filterNamePlural}`,
        },
        ...(options !== null && options !== void 0 ? options : []),
    ];
    useEffect(() => {
        if (value !== null && options === undefined && onOpen) {
            onOpen();
        }
    }, [value, onOpen, options]);
    return (React.createElement(Autocomplete, { id: id, label: `Filter by ${filterName}`, className: className, isClearAlwaysVisible: value !== null, value: value !== null && value !== void 0 ? value : "ALL", onOpen: onOpen, loading: loading, options: allOptions.map((option) => option.id), getOptionLabel: (option) => { var _a; var _b; return (_b = (_a = allOptions.find((item) => item.id === option)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ""; }, onChange: (event, value) => onChange(event, value === "ALL" ? null : value) }));
};
export default CommonListFilter;
//# sourceMappingURL=CommonListFilter.js.map